module.exports = __webpack_public_path__ + "static/img/stage.f2e2426.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/stage.jpg
// module id = SncN
// module chunks = 0